module.exports = __webpack_public_path__ + "media/images/car-b88edd8e257a94c90f0a4fa29e25dcc0.png";